import { useFormik } from "formik";
import * as Yup from "yup";

const useFormZone = (onSubmit, afterSubmit, initialValues, isEditMode) => {
  const validationSchema = Yup.object({
    commerceId: Yup.number().required("Comercio es requerido"),
    title: Yup.string().required("Nombre de zona es requerido"),
    description: Yup.string().required("La descripción es requerida"),
    status: Yup.boolean().required("El estado es requerido"),
  });

  // Valores iniciales completos
  const safeInitialValues = {
    commerceId: "",
    title: "",
    description: "",
    status: true,
    ...initialValues,
  };

  return useFormik({
    initialValues: safeInitialValues,
    validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
        await onSubmit(values);
        afterSubmit();
      } finally {
        setSubmitting(false);
      }
    },
    enableReinitialize: true,
  });
};

export default useFormZone;
